<template>
  <div class="form-group row">
    <label
      for="selectDateTime"
      class="col-sm-2 col-form-label"
      >{{label}}</label>
    <div class="col-sm-10">
      <flat-pickr
        v-model="dateTime"
        :config="config"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :placeholder="placeholder"
        id="selectDateTime"
        :readonly="readonly"
        ></flat-pickr>
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    v: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      default: function () {
        return {
          dateFormat: 'j-m-Y H : i',
          enableTime: true,
          locale: Spanish,
          allowInput: true
        }
      }
    },
    label: String,
    placeholder: String,
    readonly: Boolean
  },
  components: {
    flatPickr
  },
  computed: {
    dateTime: {
      get () {
        return this.value
      },
      set (value) {
        this.v.$touch()
        this.$emit('input', value)
      }
    }
  }
}
</script>
